import { TooltipContent } from "components/metric-card";

export const TIMELINE_TOOLTIP: TooltipContent = {
  title: "Timeline",
  text: "When the initiative starts delivering benefit and when that benefit is expected to end, e.g. due to contract expiry or end of equipment life.",
  chip: "Input",
};
